import { AddCircleOutlineOutlined } from "@mui/icons-material";
import { Button } from "@mui/material";

import HNSColors from "../../../../../ui library/HNSColors";


export default function AddButton({ label, handleAdd }) {
  return (
    <Button
      variant="outlined"
      color="primary"
      onClick={handleAdd}
      className="max-w-50 min-w-40 normal-case"
      endIcon={<AddCircleOutlineOutlined />}
      sx={{
        borderRadius: "500px",
        color: HNSColors.secondary[500],
        border: `1px solid ${HNSColors.secondary[500]}`,
        "&:hover": {
          background: HNSColors.secondary[900],
          color: HNSColors.secondary[400],
          border: `1px solid ${HNSColors.secondary[900]}`,
        },
      }}
    >
      {label}
    </Button>
  );
}
